import { Component, Inject, OnInit } from '@angular/core';
import { AuthService } from '../../../../core/services/auth.service';
import { LogService } from '../../../../core/services/log.service';
// import { EventGuestsService } from '../../services/event-guests.service';

import IdentificationTypesPageView from "./identification-types-edit.page.html";

@Component({
    selector: 'identification-types-edit-page',
    template: IdentificationTypesPageView
})

export class IdentificationTypesEditPage implements OnInit {

    isAllowed: boolean = false;

    constructor(@Inject(AuthService) private authService: AuthService,
        @Inject(LogService) private log: LogService,
        @Inject('$stateParams') private $stateParams: any) {
    }

    ngOnInit() {
        this.isAllowed = this.authService.permissionExist('IDENTIFICATION_TYPES_WRITE') ?? false;
    }

}